import React from 'react';
import Leaderboard from '../components/Leaderboard';
import { Trophy } from 'lucide-react';

const Stand = () => {
  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-8">
          <div className="inline-block bg-[#FDB913] rounded-full p-4 mb-4">
            <Trophy size={40} className="text-[#1a2332]" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-2">Klassement</h1>
          <p className="text-muted-foreground">Bekijk de huidige stand van alle deelnemers</p>
        </div>

        <Leaderboard limit={0} />
      </div>
    </div>
  );
};

export default Stand;
